import React, { Component } from "react";

export class Description extends Component {
  render() {
    return (
      <div className="description">
        {this.props.luckyNumberHomePageTexts.slice(0,3).map((item) => {
          return (
            <div className="section" key={item.textId}>
              <div className="heading">
                <h3>{item.title}</h3>
              </div>
              <p className="description">{item.text}</p>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Description;
